export default __webpack_public_path__ + "static/media/2.a74c6e43.jpg";